import {User}									from '../user/interface';
import {ApiContractState}						from './interface';

import * as API									from '../../ressources/API';


export default {
	getContractsApi: async (user: User) => {
		const response = await API.getContracts(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	putContractsApi: async (data: ApiContractState) => {
		if (!data.idContract)
			return null;

		const response = await API.putContract(data.idContract, data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	}
};
